import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import styles from './MainPage.module.css';
import sudokuImage from '../assets/images/sudoku.png';
import diamondImage from '../assets/images/diamond.png';
import comingsoonImage from '../assets/images/comingsoon.png';
import image2048 from '../assets/images/2048title.png';
import grapeImage from '../assets/images/grape.png';
import jumpImage from '../assets/images/jumpjump.png';
import speedMathImage from '../assets/images/speedmath.png';
import wordleImage from '../assets/images/wordle.png';
import SettingsModal from '../components/modals/SettingsModal';
import PatchNoteModal from '../components/modals/PatchNoteModal';
import EasterEggModal from '../components/modals/EasterEggModal';

const MainPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showPatchNoteModal, setShowPatchNoteModal] = useState(false);
  const [showEasterEggModal, setShowEasterEggModal] = useState(false);
  const [gClickCount, setGClickCount] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(0);

  const handleGClick = () => {
    const now = Date.now();
    if (now - lastClickTime > 2000) { // 2초 이내에 클릭해야 함
      setGClickCount(0);
    }
    
    setGClickCount(prev => {
      const newCount = prev + 1;
      if (newCount === 3) {
        setShowEasterEggModal(true);
        return 0;
      }
      return newCount;
    });
    
    setLastClickTime(now);
  };

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setShowShareModal(true);
    } catch (err) {
      alert('링크 복사에 실패했어요. 주소창의 URL을 직접 복사해주세요!');
      console.error('클립보드 복사 실패:', err);
    }
  };

  useEffect(() => {
    // 쿠팡 배너 초기화
    const initBanner = () => {
      if (window.PartnersCoupang) {
        try {
          const bottomContainer = document.getElementById('coupang-banner-bottom');
          const screenWidth = window.innerWidth;
          let bannerWidth, bannerHeight;

          if (screenWidth <= 375) {
            bannerWidth = "280";
            bannerHeight = "90";
          } else if (screenWidth <= 500) {
            bannerWidth = "320";
            bannerHeight = "100";
          } else {
            bannerWidth = "500";
            bannerHeight = "120";
          }

          if (bottomContainer) {
            new window.PartnersCoupang.G({
              id: 834471,
              template: "carousel",
              trackingCode: "AF1795036",
              width: bannerWidth,
              height: bannerHeight,
              tsource: "",
              container: bottomContainer
            });
          }
        } catch (error) {
          console.error('쿠팡 배너 초기화 오류:', error);
        }
      }
    };

    initBanner();

    return () => {
      const bottomBanner = document.getElementById('coupang-banner-bottom');
      if (bottomBanner) bottomBanner.innerHTML = '';
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerButtons}>
          <div className={styles.leftButtons}>
            <button 
              className={styles.headerButton}
              onClick={() => setShowPatchNoteModal(true)}
            >
              {t('patchNotes')}
            </button>
            <button 
              className={styles.headerButton}
              onClick={handleShare}
            >
              {t('share')}
            </button>
            <button 
              className={styles.headerButton}
              onClick={() => setShowContactModal(true)}
            >
              {t('contact')}
            </button>
          </div>
          <div className={styles.rightButtons}>
            <button 
              className={`${styles.headerButton} ${styles.settingsButton}`}
              onClick={() => setShowSettingsModal(true)}
            >
              <svg className={styles.settingsIcon} viewBox="0 0 24 24">
                <path d="M12 15.5A3.5 3.5 0 0 1 8.5 12 3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.65.07-.97 0-.32-.03-.65-.07-.97l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65c-.04-.24-.25-.42-.5-.42h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 12c-.04.32-.07.65-.07.97 0 .32.03.65.07.97l-2.11 1.63c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.31.61.22l2.49-1c.52.39 1.06.73 1.69.98l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.25 1.17-.59 1.69-.98l2.49 1c.22.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.63z"/>
              </svg>
            </button>
          </div>
        </div>
        <h1 className={styles.title}>
          {t('mainTitle').split('').map((char, index) => 
            char === 'G' ? (
              <span 
                key={index} 
                className={styles.easterEggChar}
                onClick={handleGClick}
                style={{ cursor: 'pointer' }}
              >
                {char}
              </span>
            ) : (
              <span key={index}>{char}</span>
            )
          )}
        </h1>
      </div>

      <div className={styles.gameList}>
        {/* 단어추리왕 */}
        <button
          className={styles.gameButton}
          onClick={() => navigate('/wordle')}
        >
          <div className={styles.gameContent}>
            <div className={styles.gameInfo}>
              <h2>{t('games.wordle.title')}</h2>
              <p>{t('games.wordle.description')}</p>
            </div>
            <div className={styles.gameImageContainer}>
              <img
                src={wordleImage}
                alt="Word Master"
                className={styles.gameImage}
              />
            </div>
          </div>
        </button>

        {/*스도쿠*/}
        <button 
          className={styles.gameButton}
          onClick={() => navigate('/sudoku')}
        >
          <div className={styles.gameContent}>
            <div className={styles.gameInfo}>
              <h2>{t('games.sudoku.title')}</h2>
              <p>{t('games.sudoku.description')}</p>
            </div>
            <div className={styles.gameImageContainer}>
              <img 
                src={sudokuImage} 
                alt="Sudoku" 
                className={styles.gameImage}
              />
            </div>
          </div>
        </button>

        {/* 2048 */}
        <button 
          className={styles.gameButton}
          onClick={() => navigate('/2048')}
        >
          <div className={styles.gameContent}>
            <div className={styles.gameInfo}>
              <h2>{t('games.2048.title')}</h2>
              <p>{t('games.2048.description')}</p>
            </div>
            <div className={styles.gameImageContainer}>
              <img 
                src={image2048} 
                alt="2048" 
                className={styles.gameImage}
              />
            </div>
          </div>
        </button>

        {/* 청포도 10 */}
        <button 
          className={styles.gameButton}
          onClick={() => navigate('/grape')}
        >
          <div className={styles.gameContent}>
            <div className={styles.gameInfo}>
              <h2>{t('games.grape.title')}</h2>
              <p>{t('games.grape.description')}</p>
            </div>
            <div className={styles.gameImageContainer}>
              <img 
                src={grapeImage} 
                alt="Grape Game" 
                className={styles.gameImage}
              />
            </div>
          </div>
        </button>

        {/* 다이아몬드 게임 */}
        <button 
          className={styles.gameButton}
          onClick={() => navigate('/diamond')}
        >
          <div className={styles.gameContent}>
            <div className={styles.gameInfo}>
              <h2>{t('games.diamond.title')}</h2>
              <p>{t('games.diamond.description')}</p>
            </div>
            <div className={styles.gameImageContainer}>
              <img 
                src={diamondImage} 
                alt="Diamond Game" 
                className={styles.gameImage}
              />
            </div>
          </div>
        </button>

        {/* 파닥파닥 */}
        <button
          className={styles.gameButton}
          onClick={() => navigate('/jump')}
        >
          <div className={styles.gameContent}>
            <div className={styles.gameInfo}>
              <h2>{t('games.jump.title')}</h2>
              <p>{t('games.jump.description')}</p>
            </div>
            <div className={styles.gameImageContainer}>
              <img
                src={jumpImage}
                alt="Jump Game"
                className={styles.gameImage}
              />
            </div>
          </div>
        </button>

        {/* 빠른 산수 챌린지 */}
        <button
          className={styles.gameButton}
          onClick={() => navigate('/speed-math')}
        >
          <div className={styles.gameContent}>
            <div className={styles.gameInfo}>
              <h2>{t('games.speedMath.title')}</h2>
              <p>{t('games.speedMath.description')}</p>
            </div>
            <div className={styles.gameImageContainer}>
              <img
                src={speedMathImage}
                alt="Speed Math"
                className={styles.gameImage}
              />
            </div>
          </div>
        </button>

        {/* Coming Soon */}
        <button 
          className={`${styles.gameButton} ${styles.comingSoonButton}`}
          onClick={(e) => e.preventDefault()}
        >
          <div className={styles.gameContent}>
            <div className={styles.gameInfo}>
              <h2>???</h2>
              <p>{t('games.comingSoon.description')}</p>
            </div>
            <div className={styles.gameImageContainer}>
              <img 
                src={comingsoonImage} 
                alt="Coming Soon" 
                className={styles.gameImage}
              />
            </div>
          </div>
        </button>
      </div>

      <div className={styles.bannerContainer}>
        <div id="coupang-banner-bottom"></div>
        <p className={styles.bannerDisclaimer}>
          {t('bannerDisclaimer.line1')}<br/>
          {t('bannerDisclaimer.line2')}
        </p>
      </div>

      {showSettingsModal && (
        <SettingsModal
          onClose={() => setShowSettingsModal(false)}
          onContact={() => {
            setShowSettingsModal(false);
            setShowContactModal(true);
          }}
          onShare={handleShare}
        />
      )}

      {showContactModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.contact.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowContactModal(false)}>
                {t('modals.contact.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showShareModal && (
        <div className="modal-overlay">
          <div className="modal share-modal">
            <p>{t('modals.share.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowShareModal(false)}>
                {t('modals.share.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPatchNoteModal && (
        <PatchNoteModal onClose={() => setShowPatchNoteModal(false)} />
      )}

      {showEasterEggModal && (
        <EasterEggModal onClose={() => setShowEasterEggModal(false)} />
      )}
    </div>
  );
};

export default MainPage;